import React, { useContext, useState, useRef } from 'react';
import { CanvasContext } from '../../../WorkflowCanvas';
import { withStyles } from '@mui/styles';
import { styles } from './ComponentNodeUtil/CustomComponentNodeUtil';
import BaseComponent from './BaseComponent';
import InlineNodeView from './InlineNodeView';
import InlineConfigPanel from '../../../ReactFlowUtil/InlineConfigPanel';
import { useParams } from 'react-router';

const VersionCanvasComponent = ({ id, data, classes, selected, xPos, yPos }) => {
  const { modeInfo } = useContext(CanvasContext);
  if (modeInfo === undefined) {
    return <BaseComponent classes={classes} data={data} isConnectable={false} />;
  }

  const parentRef = useRef(null);
  const { productionVersion } = useContext(CanvasContext);
  const params = useParams();
  const projectId = params.id;
  const version = params.version || productionVersion;

  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      ref={parentRef}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{ width: 520, display: 'flex', flexDirection: 'column', alignItems: 'center' }}
    >
      <InlineNodeView
        data={data}
        nodeId={id}
        saving={false}
        isHovered={isHovered}
        addLinkedConditionalPath={() => {}}
        currentXPosition={xPos}
        currentYPosition={yPos}
        readOnly
      >
        <InlineConfigPanel
          componentId={id}
          componentType={data.type}
          projectId={projectId}
          version={version}
          nodeData={data}
          readOnly
        />
      </InlineNodeView>
    </div>
  );
};

export default withStyles(styles)(VersionCanvasComponent);
